<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Settings</h1>

<div>
  <!-- progress -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading || isWorking"></mat-progress-spinner>

  <!-- container -->
  <div *ngIf="userSettings">
    <h3>Streaming</h3>

    <!-- form -->
    <form #form="ngForm" (ngSubmit)="save()" novalidate>

      <!-- isNativeClientEnabled -->
      <div class="form-field">
        <mat-checkbox name="isNativeClientEnabled" [(ngModel)]="userSettings.isNativeClientEnabled">Enable native client</mat-checkbox>
      </div>
      <div class="form-field-note">
        When enabled, we try to launch AVEVA ERM using the <a href="https://clients.amazonappstream.com">native AppStream 2.0 client for Windows</a>.
        If the client is not installed, AVEVA ERM can still be launched in the browser.
      </div>

      <!-- form actions -->
      <div class="form-actions" fxLayout="row" fxLayoutGap="8px">
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid || isWorking">Save</button>
        <a mat-raised-button [routerLink]="['..']">Cancel</a>
      </div>
    </form>
  </div>
</div>